import { ExplorerJobPostCard } from './ExplorerJobPostCard';

export { ExplorerJobPostCard };
export default ExplorerJobPostCard;
